import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  paper: {
    width: "100%",
    maxWidth: "250px",
  },
}));
